import { createStore } from 'redux';
import reducers from './reducers';

let persistedState = {}
try {
    const state = sessionStorage.getItem("userData");
    if (state) {
        persistedState.userData = JSON.parse(state)
    }
} catch (e) {
    console.log(e);
}
try {
    const state = sessionStorage.getItem("menuData");
    if (state) {
        persistedState.menuData = JSON.parse(state)
    }
} catch (e) {
    console.log(e);
}
try {
    const state = sessionStorage.getItem("configData");
    if (state) {
        let object_data = JSON.parse(state);
        if(object_data&&object_data.hasOwnProperty('expirationTime')){
            const timestampSeconds = Math.floor(Date.now() / 100000);
            if(object_data.expirationTime!=timestampSeconds){
                sessionStorage.removeItem("configData");
            }else{
                persistedState.configData = object_data;
            }
        }else{
            persistedState.configData = {};
        }
    }
} catch (e) {
    console.log(e);
}
try {
    const state = sessionStorage.getItem("configSystemData");
    if (state) {
        let object_data = JSON.parse(state);
        if(object_data&&object_data.hasOwnProperty('expirationTime')){
            const timestampSeconds = Math.floor(Date.now() / 100000);
            if(object_data.expirationTime!=timestampSeconds){
                sessionStorage.removeItem("configSystemData");
            }else{
                persistedState.configSystemData = object_data;
            }
        }else{
            persistedState.configSystemData = {};
        }
    }
} catch (e) {
    console.log(e);
}

const store = createStore(reducers, persistedState);

store.subscribe(() => {
    try {
        const state = JSON.stringify(store.getState().userData);
        // console.log(state)
        sessionStorage.setItem("userData", state);
    } catch (e) {
        console.log(e);
    }
    try {
        const state = JSON.stringify(store.getState().menuData);
        // console.log(state)
        sessionStorage.setItem("menuData", state);
    } catch (e) {
        console.log(e);
    }
    try {
        const state = JSON.stringify(store.getState().configData);
        if(state){
            sessionStorage.setItem("configData", state);
        }
    } catch (e) {
        console.log(e);
    }
    try {
        const state = JSON.stringify(store.getState().configSystemData);
        if(state){
            sessionStorage.setItem("configSystemData", state);
        }
    } catch (e) {
        console.log(e);
    }
});

export default store;
